import { render, staticRenderFns } from "./ReadyMadePDF.vue?vue&type=template&id=2bc9a7f8&scoped=true&"
import script from "./ReadyMadePDF.vue?vue&type=script&lang=js&"
export * from "./ReadyMadePDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc9a7f8",
  null
  
)

export default component.exports